import router from './router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import store from '@/vuex/store'
import {
  Message,
  MessageBox
} from 'element-ui';

let whiteList = "/index";
router.beforeEach((to, from, next) => {
  NProgress.start();
  if (localStorage.getItem("ieStatus") != 1) {
    if (!!window.ActiveXObject || "ActiveXObject" in window) {
      MessageBox.confirm('您正在使用IE浏览器，为了更好的网站体验，建议您使用谷歌、火狐、360极速模式等高版本的浏览器', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '不再提醒',
        cancelButtonClass: "greyBg",
        type: 'warning'
      }).then(() => {

      }).catch(() => {
        localStorage.setItem("ieStatus", 1);
      });
    }
  }
  let userInfo = JSON.parse(sessionStorage.getItem("userInfo")); //获取用户登录信息
  let reback = JSON.parse(sessionStorage.getItem("reback")||JSON.stringify({contact:[]}));
  if (userInfo) {
    //用户已登录,未完善信息，跳转用户页面完善信息
    if (reback.contact.length==0) {
      Message.warning("首次登录需完善联络人信息");
      if (to.path == "/userInfo") {
        next();
      } else {
        NProgress.done();
        next("/userInfo");
      }
    } else {
      next();
    }
  } else {
    //用户未登录
    if (to.meta.pass == whiteList) {
      // 白名单路由可直接跳转
      next();
    } else {
      //不在白名单，先登录
      if (to.path != "/userInfo") {
        Message.error("请登录后访问");
      }

      NProgress.done();
      store.commit("showLoading", true);
      //保存页面路由，用于登录后直接跳转
      sessionStorage.setItem("next", to.path);
      if (from.meta.pass == whiteList) {
        next(from.path);
      } else {
        next("/index");
      }
    }
  }
});

router.afterEach(() => {
  NProgress.done();
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
})



// WEBPACK FOOTER //
// ./src/permission.js